import { setCheckInDay, setCheckOutDay } from 'features/userSlice';
import { useGetBookingData } from 'hooks';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import './AvailableFutureDates.css';

const AvailableFutureDates = ({ dates }) => {
    if (dates.length === 0) {
        return null;
    }
    const dispatch = useDispatch();
    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);

    const { getBookingData } = useGetBookingData();
    return (
        <div className="ab-available-future-dates-cnt">
            {/* TODO: DISPLAY ONLY TWO FOR NOW */}
            {dates.slice(0, 2).map((date) => {
                const onClick = () => {
                    dispatch(setCheckInDay({ day: date.futureDateData[0] }));
                    dispatch(setCheckOutDay({ day: date.futureDateData[1] }));
                    getBookingData({
                        checkInDate: date.futureDateData[0].date,
                        checkOutDate: date.futureDateData[1].date,
                    });
                };

                return (
                    <div
                        className="ab-available-future-date"
                        key={date?.reactID}
                        onClick={onClick}
                    >
                        <div className="ab-available-future-date-period">
                            {date?.dateDisplay} - {date?.dateToDisplay}
                        </div>
                        <div className="ab-available-future-date-period">
                            {date?.min_stay} {Lang?.nights}
                        </div>
                        <div className="ab-available-future-date-price">
                            {date?.priceStr}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

const DateType = PropTypes.shape({
    reactID: PropTypes.number,
    dateDisplay: PropTypes.string,
    dateToDisplay: PropTypes.string,
    priceStr: PropTypes.string,
});

AvailableFutureDates.propTypes = {
    dates: PropTypes.arrayOf(DateType),
};

export default AvailableFutureDates;
